<template>
  <div id="app">
    <div class="sidebar" v-show="showNav">
      <router-link to="/user">用户</router-link>
      <router-link to="/home">主页</router-link>
      <router-link to="/kamil">卡密</router-link>
      <router-link to="/Apikey">aApi</router-link>
      <router-link to="/Order">订单</router-link>
      <router-link to="/Config">配置</router-link>
      <router-link to="/Tips">Tips</router-link>
      <router-link to="/NaiPointApi">官点</router-link>
      <router-link to="/UserApi">大图用户</router-link>
      <router-link to="/ProxyConfigView">ip代理</router-link>
<!--      <router-link to="/Recharge">代充</router-link>-->
<!--      <router-link to="/JingXiangRecharge">镜充</router-link>-->
<!--      <router-link to="/Claude">claude</router-link>-->
<!--      <router-link to="/Tavern">酒馆</router-link>-->
      <router-link to="/SillyTokenInfoPage">酒馆token</router-link>
      <router-link to="/SillyApiKeysPage">酒馆apikey</router-link>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      showNav: true
    };
  },
  watch: {
    // 监听路由变化
    $route(to) {
      // 根据路径判断是否显示导航栏
      this.showNav = to.path !== '/' && to.path !== '/login';
    }
  },
  created() {
    // 组件创建时判断是否显示导航栏
    this.showNav = this.$route.path !== '/' && this.$route.path !== '/login';
  }
}
</script>
<style>
#app {
  display: flex;
  flex-direction: row;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.sidebar a {
  padding-top: 5px;  /* 设置上内边距 */
  padding-bottom: 5px; /* 设置下内边距 */
}
.sidebar {
  display: flex;
  flex-direction: column;
  padding: 30px;
}

.sidebar a {
  font-weight: bold;
  color: #2c3e50;
}

.sidebar a.router-link-exact-active {
  color: #42b983;
}

.content {
  flex: 1;
  padding: 30px;
}
</style>
